import React from "react";
import Text from "@amzn/meridian/text";
import Column from "@amzn/meridian/column";
import Row from "@amzn/meridian/row";
import Link from "@amzn/meridian/link";
import { ROUTES_AT_RISK } from "./utils/EntityStatusManager";
import Box from "@amzn/meridian/box";
import { SELECT_STATUS } from "./utils/ReducerActionTypes";

const RouteGroupedStatusView = ({ title, statusItems, dispatchF }) => {
  const handleStatusClick = (statusTypes) => {
    dispatchF({ type: SELECT_STATUS, status: statusTypes });
  };

  return (
    <Box type="outline" spacingInset={"medium"}>
      <Column spacing="small">
        <Text type="h200">{title}</Text>
        <Row spacing="medium" wrap>
          {statusItems.map((item, index) => (
            <Column key={index} spacing="medium">
              <Text type="b300">{item.label}</Text>
              <Text
                type="d50"
                className={
                  item.label === ROUTES_AT_RISK ? "at-risk-number" : ""
                }
              >
                <Link
                  type="secondary"
                  onClick={() => handleStatusClick(item.statusTypes)}
                >
                  {item.value}
                </Link>
              </Text>
            </Column>
          ))}
        </Row>
      </Column>
    </Box>
  );
};

export default RouteGroupedStatusView;



// WEBPACK FOOTER //
// ./src/components/RouteStatus/RouteGroupedStatusView.js